import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import Icon, { CloseOutlined, LogoutOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { sessionSelectors } from 'store/state/selectors';
import { ReactComponent as openInNew } from 'assets/svgs/openInNew.svg';
import {
  IUserMenuItem,
  useUserMenuItems,
} from 'components/UI/UserMenu/useUserMenuItems';
import * as S from './styles';

interface Props {
  isOpen: boolean;
  setOpen: (arg0: boolean) => void;
}

function MobileMenu({ isOpen, setOpen }: Props) {
  const { name: userName } = useSelector(sessionSelectors.getRoot);
  const { t } = useTranslation('translation', { keyPrefix: 'header' });
  const { ordersItems, supportItems, logout } = useUserMenuItems();

  const onClose = () => {
    setOpen(false);
  };

  const renderItem = ({
    key,
    label,
    icon,
    external,
    onClick,
  }: IUserMenuItem) => (
    <li key={key}>
      <S.MenuItem
        onClick={() => {
          onClick();
          onClose();
        }}
      >
        <S.ItemIcon aria-hidden>{icon}</S.ItemIcon>
        <S.ItemLabel>{label}</S.ItemLabel>
        {external && (
          <S.ExternalIcon aria-hidden>
            <Icon component={openInNew} />
          </S.ExternalIcon>
        )}
      </S.MenuItem>
    </li>
  );

  return (
    <S.MobileMenu
      width="100%"
      placement="right"
      onClose={onClose}
      closable={false}
      visible={isOpen}
      title={null}
    >
      <S.DrawerHeader>
        <S.Brand>
          <S.Logo aria-hidden />
          <S.BrandName>{t('veilingOnline')}</S.BrandName>
        </S.Brand>
        <S.IconButton aria-label="Fechar menu" onClick={onClose}>
          <CloseOutlined aria-hidden />
        </S.IconButton>
      </S.DrawerHeader>

      <S.DrawerBody>
        <S.WelcomeMessage>
          <S.Welcome>{t('welcome')}</S.Welcome>
          <S.UserName>{userName}</S.UserName>
        </S.WelcomeMessage>

        <nav aria-label="Menu">
          <S.SectionTitle>Menu</S.SectionTitle>
          <S.MenuList>{ordersItems.map(renderItem)}</S.MenuList>
          <S.Divider />
          <S.SectionTitle>Suporte</S.SectionTitle>
          <S.MenuList>{supportItems.map(renderItem)}</S.MenuList>
        </nav>
      </S.DrawerBody>

      <S.DrawerFooter>
        <S.LogoutButton onClick={logout}>
          Encerrar sessão <LogoutOutlined aria-hidden />
        </S.LogoutButton>
      </S.DrawerFooter>
    </S.MobileMenu>
  );
}

export default memo(MobileMenu);
